export enum Role {
    Tech = 'CallCenterTech',
    Admin = 'CallCenterAdmin',
    Super = 'ApplicationAdmin'
}
